import { createSelector } from 'reselect';

import { getConfigurator } from './getConfigurator';

export const getBootstrapper = createSelector(
  getConfigurator,
  configurator => configurator.bootstrapper,
);
